export default {
  namespaced: true,
  state: {
    // Permisos para secciones del sistema
    isPorEnviar: false,
    isPorAprobar: false,
    isPorRealizar: false,
    isEnviados: false,
    isConfirmados: false,
    isRechazados: false,
    isTemplates: false,
    isReporte: false,
  },
  mutations: {
    setIsPorEnviar(state, payload) {
      state.isPorEnviar = payload;
    },
    setIsPorAprobar(state, payload) {
      state.isPorAprobar = payload;
    },
    setIsPorRealizar(state, payload) {
      state.isPorRealizar = payload;
    },
    setIsEnviados(state, payload) {
      state.isPorRealizar = payload;
    },
    setIsConfirmados(state, payload) {
      state.isConfirmados = payload;
    },
    setIsRechazados(state, payload) {
      state.isRechazados = payload;
    },
    setIsTemplates(state, payload) {
      state.isTemplates = payload;
    },
    setIsReporte(state, payload) {
      state.isReporte = payload;
    },

    //
  },
  actions: {
    AccionCambiarIsPorEnviar({ commit }, data) {
      commit("setIsPorEnviar", data);
    },
    AccionCambiarIsPorAprobar({ commit }, data) {
      commit("setIsPorAprobar", data);
    },
    AccionCambiarIsPorRealizar({ commit }, data) {
      commit("setIsPorRealizar", data);
    },
    AccionCambiarIsEnviados({ commit }, data) {
      commit("setIsEnviados", data);
    },
    AccionCambiarIsConfirmados({ commit }, data) {
      commit("setIsConfirmados", data);
    },
    AccionCambiarIsRechazados({ commit }, data) {
      commit("setIsRechazados", data);
    },
    AccionCambiarIsTemplates({ commit }, data) {
      commit("setIsTemplates", data);
    },
    AccionCambiarIsReporte({ commit }, data) {
      commit("setIsReporte", data);
    },
  },
};
